import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/logo.svg'
import { NavLink } from 'react-router-dom';


class Header extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            show: false
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            show: !this.state.show
        })
    }

    render(){

        return(
            <div>
                <div className="bg-apHeader py-2 md:px-10 px-2">
                    <nav className="flex-row md:justify-end text-center md:flex">
                        <a href="tel:09963322990" className="mr-5 text-as text-sm font-semibold hover:text-pink-600"><FontAwesomeIcon icon={faPhoneAlt} className="mr-2"/>09963322990</a>
                        <a href="mailto:info@amitpaintings.com" className="text-as text-sm font-semibold hover:text-pink-600"><FontAwesomeIcon icon={faEnvelope} className="mr-2"/>info@amitpaintings.com</a>
                    </nav>
                </div>
                <div className="bg-white md:px-10 px-2 py-2 border-b flex justify-between">
                    <div className="flex flex-row justify-between items-center w-full md:w-1/2">
                        
                        <a href="/"><img src={logo} width="120" alt="" srcSet="" /></a>

                        <div className="block md:hidden lg:hidden">
                            <button className="flex items-center px-3 py-2 border rounded text-ap border-ap" onClick={this.handleSubmit}>
                                { this.state.show ? 
                                    <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path  d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
                                    </svg> : 
                                    <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path className="ifclose" d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                                    </svg>
                                }
                                    
                            </button>
                        </div>
                    </div>

                    <ul className= "hidden md:flex md:flex-row items-center mainHeader text-base">
                        <li className="linkHeader"><NavLink to="/" exact={true}>Home</NavLink>
                        </li>
                        <li className="linkHeader"><NavLink to="/projects">Projects</NavLink></li>
                        <li className="linkHeader"><NavLink to="/services">Services</NavLink></li>
                        <li className="linkHeader"><NavLink to="/about">About us</NavLink></li>
                        <li className="linkHeader text-white btn-secondary px-4 py-2 uppercase rounded text-xs tracking-wide font-semibold"><NavLink to="/contact-us">Contact us</NavLink></li>
                    </ul>
                </div>
                <div className ={this.state.show ? 'block' : 'hidden'}>
                    <ul className="bg-white p-2">
                        <li className="linkHeader px-2 py-2 hover:bg-gray-300" onClick={this.handleSubmit}><NavLink to="/" exact={true}>Home</NavLink>
                        </li>
                        <li className="linkHeader px-2 py-2 hover:bg-gray-300" onClick={this.handleSubmit}><NavLink to="/projects">Projects</NavLink></li>
                        <li className="linkHeader px-2 py-2 hover:bg-gray-300" onClick={this.handleSubmit}><NavLink to="/services">Services</NavLink></li>
                        <li className="linkHeader px-2 py-2 mb-2 hover:bg-gray-300" onClick={this.handleSubmit}><NavLink to="/about">About us</NavLink></li>
                        <li className="linkHeader text-white btn-secondary px-4 py-2 uppercase rounded text-xs tracking-wide font-semibold" onClick={this.handleSubmit}><NavLink to="/contact-us">Contact us</NavLink></li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header.jsx